import { getScopeActions } from './scopeActionMap';
import { createScopedDispatchers } from '../../shared/selectHandlers/createScopedDispatchers';

export const selectAllDispatchHandler = (
  dispatch, scope, name, locationList, specificLocationList, machineList, status
) => {
  const { selectAllDispatch } = createScopedDispatchers(getScopeActions(scope), 'controller');
  selectAllDispatch(dispatch, name, locationList, specificLocationList, machineList, status);
};
